module.exports = "https://static.wmbcdn.com/uniweb/images/f868f3e9dc393a0feb661bcad0313869.svg";